import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
import { SelfResponseDefinitionSummaryModel } from '@/Models/selfResponseDefinitionSummaryModel';
import apiClient from '@/Services/Clients/apiClient';

const SELF_RESPONSE_DEFINITION_BASE_URL = 'api/selfresponsedefinition';

export default class ResponseFormDefinitionService {

  public static getResponseDefinitions = (): Promise<SelfResponseDefinitionSummaryModel[]> => {
    const contextData = useContextDataStore();
    const agencyId = contextData.userData.agencyId;
    const resourceUrl = `${SELF_RESPONSE_DEFINITION_BASE_URL}/${agencyId}`;

    return apiClient.get(resourceUrl);
  };

  public static getResponseFormById = (formId: string) => {
    const contextData = useContextDataStore();
    const agencyId = contextData.userData.agencyId;
    const resourceUrl = `${SELF_RESPONSE_DEFINITION_BASE_URL}/${agencyId}/${formId}`;

    return apiClient.get(resourceUrl);
  };
}